import React, { useState } from 'react';
import { Row, Col, Input, Button, Alert, Container, Label } from "reactstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
// import images
// import logodark from "../../assets/images/logo-dark.png";
// import logolight from "../../assets/images/logo-light.png";
import { resetPassword } from '../../helper/api-methods';

function ResetPassword(){
    let params = useParams();
    const token = params.token;
    const [ password, setPassword ] = useState("");
    const [ confirmPassword, setConfirmPassword ] = useState("");
    const [ loading, setLoading ] = useState(false);
    const [ errors, setErrors ] = useState({ password: "", confirmPassword: "", apiError: ""});
    const history = useNavigate();

    const validateSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const error = { password: "", confirmPassword: "", apiError: ""}
        let flag = false;
        if ( password !== confirmPassword ) {
            error.confirmPassword = 'Passwords do not match.';
            flag = true
        }
        if (!password || password.replaceAll(/\s/g,'').length < 6) {
            error.password = 'Please provide a valid password';
            flag = true
        }
        if (!confirmPassword || confirmPassword.replaceAll(/\s/g,'').length < 6) {
            error.confirmPassword = 'Please provide a valid password';
            flag = true
        }
        setErrors(error);
        if(!flag){
            resetPassword("/reset-password",{token: token, password: password}).then(({data})=>{
                history('/');
            }).catch((e)=>{
                const error = { password: "", confirmPassword: "", apiError: e}
                setErrors(error);
                resetForm();
                setLoading(false)
            })
        }
    }

    const resetForm = () => {
        setPassword("");
        setConfirmPassword("");
    }
    const resetErrors = () => {
        const error = { password: "", confirmPassword: "", apiError: ""}
        setErrors(error);
    }

    return (
        <div>
            <Container fluid className="p-0">
                <Row className="g-0">
                    <Col lg={4}>
                        <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100 bg-white">
                            <div className="w-100">
                                <Row className="justify-content-center">
                                    <Col lg={9}>
                                        <div>
                                            <div className="text-center">
                                                <div>
                                                    <Link to="/" className="">
                                                        {/* <img src={logodark} alt="" height="60" className="auth-logo logo-dark mx-auto" />
                                                        <img src={logodark} alt="" height="60" className="auth-logo logo-light mx-auto" /> */}
                                                    </Link>
                                                </div>
                                                <h4 className="font-size-18 mt-4">Reset Password</h4>
                                                <p className="text-muted">Reset your password to Walking Challenge.</p>
                                            </div>
                                            {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}
                                            <div className="p-2 mt-5">
                                                <form className="form-horizontal" onSubmit={validateSubmit}>
                                                    <div className="auth-form-group-custom mb-4">
                                                        <i className="ri-shield-keyhole-line auti-custom-input-icon"></i>
                                                        <Label htmlFor="userpassword">New Password</Label>
                                                        <Input name="password" value={password} onChange={(e)=>{setPassword(e.target.value)}} type="password" className={`form-control ${errors.password ? "is-invalid" : ""}`} id="userpassword" placeholder="Enter New Password" />
                                                        {errors.password ? <div className="invalid-feedback">{errors.password}</div> : null}
                                                    </div>
                                                    <div className="auth-form-group-custom mb-4">
                                                        <i className="ri-shield-keyhole-line auti-custom-input-icon"></i>
                                                        <Label htmlFor="confirmPassword">Confirm Password</Label>
                                                        <Input name="confirmPassword" value={confirmPassword} onChange={(e)=>{setConfirmPassword(e.target.value)}} type="password" className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`} id="confirmPassword" placeholder="Re-Enter New Password" />
                                                        {errors.confirmPassword ? <div className="invalid-feedback">{errors.confirmPassword}</div> : null}
                                                    </div>
                                                    <div className="mt-4 text-center">
                                                        <Button color="success" disabled={loading} className="w-md waves-effect waves-light" type="submit">{ loading ? "Please Wait" : "Reset" }</Button>
                                                    </div>
                                                    <div className="mt-4 text-center">
                                                        <Link to="/login" className="text-muted"><i className="mdi mdi-lock me-1"></i> Back to login</Link>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="mt-5 text-center">
                                                <p>© {new Date().getFullYear()} Walking Challenge. All Rights Reserved</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col lg={8}>
                        <div className="authentication-bg">
                            <div className="bg-overlay"></div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ResetPassword